import React, { useMemo } from "react";
import { convertObject } from "src/v2/services/data/converters/hubspot";
import {
    flowstepUIControl,
    HSObject
} from "src/v2/types/data";
import useDataLoader from "src/v2/utils/useDataLoader";
import ObjectPicker from "../ObjectPicker";
import { DataObject } from 'shared/providers/types';

interface Props extends flowstepUIControl<HSObject[], DataObject> {
    errorMessage?: string;
    placeholder?: string;
}

const HSObjectPicker: React.FC<Props> = ({ value, data, onChange, disabled, errorMessage, placeholder }) => {
    const objects = useDataLoader(data);
    const converted = useMemo(() => {
        return objects ? objects.map(convertObject) : []
    }, [objects])

    return (
      <ObjectPicker
        value={value}
        data={converted}
        onChange={onChange}
        disabled={disabled}
        errorMessage={errorMessage}
        placeholder={placeholder}
      />
    )
};

export default HSObjectPicker;
